import { Grid, Paper } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getLogsDashboard } from "components/axios/activityAxios";
import { nowFormat } from "components/date_picker/dateUtils";
import AccessMainPanel from "components/inner/activity/AccessMainPanel";
import KpiSummary from "components/inner/activity/KpiSummary";
import RecentUsers from "components/inner/activity/RecentUsers";

// const REFRESH_INTERVAL  = Number(process.env.REACT_APP_REFRESH_INTERVAL ) || 60000;
const REFRESH_INTERVAL  = 60000;

const ActivityDashboard = () => {

  const today = nowFormat("YYYY-MM-DD");
  const { data: dashboardData } = useQuery({
    queryKey: ["log-dashboard", today],
    queryFn: () =>
        getLogsDashboard({date: today}),

    refetchInterval: REFRESH_INTERVAL,
    staleTime: REFRESH_INTERVAL,

    refetchOnMount: "always",
    
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: true,

    placeholderData: previousData => previousData,
  });

  // const dashboardData = data?.dashboardData;

  if (!dashboardData) {
    return "Loading...";
  }
  return (
    <Grid container spacing={2} sx={{mt: 1}}>

      {/* KPI */}
      <Grid item xs={12}>
        <KpiSummary data={dashboardData?.summary} />
      </Grid>

      {/* MAIN */}
      <Grid item xs={12} md={8}>
        <AccessMainPanel data={dashboardData?.menuStatistics} />
      </Grid>

      {/* SIDE */}
      <Grid item xs={12} md={4}>
        <RecentUsers data={dashboardData?.recentUsers} />
      </Grid>

      {/* FULL LOG TABLE (optional 확장 영역) */}
      {/* <Grid item xs={12}>
        <Paper sx={{ p: 2, height: 300 }}>
          전체 접속 로그 테이블 영역 (추후 추가)
        </Paper>
      </Grid> */}

    </Grid>
  );
}

export default ActivityDashboard;